import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  CommunityProfileInfoHost,
  CommunityProfileSections,
  CommunityProfileWidgetDefinition,
} from '@trp/community/interfaces';
import { PipesModule } from '@trp/community/shared/ui';
import {
  PrivateCommunityInformation,
  PublicCommunityInformation,
} from '@trp/nationaldb/interfaces';
import { CommunityWidgetComponent } from '../community-widget';
import { CommunityWidgetContentComponent } from '../community-widget-content';
import { CommunityWidgetHeaderComponent } from '../community-widget-header';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'trp-standard-widget',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    CommunityWidgetHeaderComponent,
    CommunityWidgetComponent,
    CommunityWidgetContentComponent,
    PipesModule,
  ],
  templateUrl: './standard-widget.component.html',
  styleUrls: ['./standard-widget.component.scss'],
})
export class StandardWidgetComponent<
  TSection extends CommunityProfileSections
> {
  @Input() contactHref: string | null = null;

  @Input() widgetDefinition!:
    | CommunityProfileWidgetDefinition<TSection>
  @Input() sectionCommunityInfo!: CommunityProfileInfoHost[TSection];
  @Input() communityInfo!:
    | PrivateCommunityInformation
    | PublicCommunityInformation;

  getUnavailableMessage(): string {
    const message = this.widgetDefinition.unavailableResolver(this.sectionCommunityInfo);
    // Resolve the {{contactHref}} placeholder baked into the (param-less) translated
    // message with the state-aware contact link, falling back to the default mailto.
    return message.replace(
      /\{\{contactHref\}\}/g,
      this.contactHref ?? 'mailto:solutionshub@recyclingpartnership.org'
    );
  }
}
